// TODO: sao testes de exportacao
export * from './lib/hhh/hhh.component';
export * from './lib/button/button.component';
// TODO: sao testes de exportacao

export * from './lib/components/form-address/form-address.component';
export * from './lib/components/app-maintenance/app-maintenance.component';
export * from './lib/components/card-dealer/card-address.component';
export * from './lib/components/card-opening-hours/card-opening-hours.component';
export * from './lib/components/logout-remote-component/logout-remote-component.component';
export * from './lib/components/form/phone/phone.component';
export * from './lib/components/titles/numbered-title/numbered-title.component';
export * from './lib/components/dropdown/v2/custom-dropdown.component';
export * from './lib/components/list-options-radio/list-options-radio.component';
export * from './lib/components/budget/budget-final.component';
export * from './lib/components/modal/modal.component';
export * from './lib/components/schedule/card/open/card-open-schedule.component';
export * from './lib/components/payments/status/status-payment.component';
export * from './lib/components/alert/alert-information.component';
export * from './lib/components/modal/modal.component';
export * from './lib/components/schedule/card/driver/driver-information.component';
export * from './lib/components/titles/page-title/title-page.component';
export * from './lib/components/tooltip/tooltip.component';
export * from './lib/components/description/items-service/description-items-service.component';
export * from './lib/components/tracker/tracker.component';
export * from './lib/components/notification/notification.module';
export * from './lib/components/notification/services/notification.service';
export * from './lib/components/notification/top-banner/top-banner.component';
export * from './lib/components/notification/models/notification.model';
export * from './lib/components/circular-indicator/circular-indicator.component';
export * from './lib/components/linear-indicator/linear-indicator.component';

export * from './lib/components/ui/selectableOption/selectableOption.component'
export * from './lib/components/bottom-sheet/bottom-sheet.component';
export * from './lib/components/tooltip/tooltip.component';
export * from './lib/components/description/items-service/description-items-service.component';
export * from './lib/components/optionList/optionList.component';
export * from './lib/components/comment-box/comment-box.component';


// TODO: achar uma melhor forma de exportar esses modelos
export * from './lib/interface/salesforce';
export * from './lib/interface/vehicle/vehicle.model';
export * from './lib/interface/user/user.model';
export * from './lib/interface/schedule/schedule.model';
export * from './lib/interface/schedule/default/schedule.model';
export * from './lib/interface/revision/revision-part-vo.model';
export * from './lib/interface/quotation/quotationVO.model';
export * from './lib/interface/quotation/quotation-schedule-detail.model';
export * from './lib/interface/order/order-list.model';
export * from './lib/interface/order/optional-services-list.model';
export * from './lib/interface/response/response.model';
export * from './lib/interface/autosuggest/suggest.model';
export * from './lib/interface/coordinate/ICoordinate.model';
export * from './lib/interface/travel/ITravelSummary.model';
export * from './lib/interface/travel/IRoutesTravel.model';
export * from './lib/interface/dealer/dealer.model';
export * from './lib/interface/dealer/dealer-by-location.model';
export * from './lib/interface/dealer/dealer-service-hours.model';
export * from './lib/interface/calendar/calendar.model';
export * from './lib/interface/calendar/selected-hour-date.model';
export * from './lib/interface/calendar/selected-calendar-date.model';
export * from './lib/interface/feature-toggle/feature-toggle.model';

export * from './lib/utils/utils';
export * from './lib/utils/translate-loader';
export * from './lib/enums/Source.enum';

export * from './lib/services/dropdowm.service';
